import { render, staticRenderFns } from "./PatientRequests.vue?vue&type=template&id=714ef90e&scoped=true"
import script from "./PatientRequests.vue?vue&type=script&lang=js"
export * from "./PatientRequests.vue?vue&type=script&lang=js"
import style0 from "./PatientRequests.vue?vue&type=style&index=0&id=714ef90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ef90e",
  null
  
)

export default component.exports